import React, {Component} from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import {t} from 'l10n';

import {
//    getRoomsHd,
    getRoomsNeo,
    getPersonalRooms,
    getLastRealGifts,
    getLastWallMaterials,
    getLastBobstoreWardrobe,
    getLastBobstoreSubmissions,
    getLatestFilmsAmateurs,
    getLastVirtualGifts,
    getMessageOfDay
} from 'reducers/main';

import {getMemberPersonalRoom} from 'reducers/member';

import HeaderIndex from '../components/index/HeaderIndex';
import Footer from '../components/Footer';
import RoomItemNeo from '../components/index/RoomItemNeo';
import RoomItemPersonal from '../components/index/RoomItemPersonal';
import MyBobTV from '../components/index/MyBobTV';

import XXLFunctions from '../components/index/XXLFunctions';
import FavouritesIndex from '../components/index/FavouritesIndex';
import GenerousUsersIndex from '../components/index/GenerousUsersIndex';

import LastItemsList from "../components/index/List";

import {getReturnPath} from '../utils/url';
import Loading from 'components/Loading';

import 'sass/index.scss';

const REAL_GIFT_COUNT = 5;
const WALL_MATERIALS_COUNT = 5;
const BOBSTORE_WARDROBE_COUNT = 5;
const BOBSTORE_SUBMISSION_COUNT = 5;
const VIRTUAL_GIFTS_COUNT = 5;
const AMATEUR_FILMS_COUNT = 5;

const ROOM_REFRESH_INTERVAL = 60;

class IndexContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            topListTab: 1
        }
    }

    refreshRoomList() {
        let {dispatch, currentUser} = this.props;

        this.constructor.fetchRoomData({dispatch});

        if (currentUser && currentUser.isLoggedIn()) {
            dispatch(getMemberPersonalRoom());
        }
    }

    componentDidMount() {
        let {
            dispatch,
            rooms,
            lastRealGifts,
            lastWallPosts,
            lastBobstoreWardrobe,
            lastBobstoreSubmissions,
            latestFilmsAmateurs,
            lastVirtualGifts,
            siteDescription,
        } = this.props;

        if (isEmpty(rooms)) {
            this.constructor.fetchRoomData({dispatch});
        }

        if (isEmpty(lastRealGifts)) {
            this.constructor.fetchRealGifts({dispatch});
        }

        if (isEmpty(lastWallPosts)) {
            this.constructor.fetchLastWallMaterials({dispatch});
        }

        if (isEmpty(lastBobstoreWardrobe)) {
            this.constructor.fetchLastBobstoreWardrobe({dispatch});
        }

        if (isEmpty(lastBobstoreSubmissions)) {
            this.constructor.fetchLastBobstoreSubmissions({dispatch});
        }

        if (isEmpty(latestFilmsAmateurs)) {
            this.constructor.fetchLatestFilmsAmateurs({dispatch});
        }

        if (isEmpty(lastVirtualGifts)) {
            this.constructor.fetchLastVirtualGifts({dispatch});
        }

        if (isEmpty(siteDescription)) {
            this.constructor.fetchSiteDescription({dispatch});
        }

        this.intervalHandle = setInterval(() => { this.refreshRoomList(); }, ROOM_REFRESH_INTERVAL*1000);
    }

    componentWillReceiveProps(nextProps) {
        let {dispatch} = nextProps;

        // handling log in and log out
        if ( (!this.props.currentUser || !this.props.currentUser.isLoggedIn()) && nextProps.currentUser && nextProps.currentUser.isLoggedIn()) {
            dispatch(getMemberPersonalRoom());
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalHandle);
    }

    setTopListTab(tabId) {
        this.setState({topListTab: tabId});
    }

    static fetchData({dispatch}) {
        return [
            ...this.fetchRoomData({dispatch}),

            this.fetchRealGifts({dispatch}),
            this.fetchLastWallMaterials({dispatch}),
            this.fetchLastBobstoreWardrobe({dispatch}),
            this.fetchLastBobstoreSubmissions({dispatch}),
            this.fetchLatestFilmsAmateurs({dispatch}),
            this.fetchLastVirtualGifts({dispatch}),
            this.fetchSiteDescription({dispatch}),
            FavouritesIndex.fetchData({dispatch, params: {page: 1}}),
            GenerousUsersIndex.fetchData({dispatch, params: {page: 1}})
        ];
    }

    static fetchRealGifts({dispatch}) { return dispatch(getLastRealGifts(REAL_GIFT_COUNT)) }
    static fetchLastWallMaterials({dispatch}) { return dispatch(getLastWallMaterials(WALL_MATERIALS_COUNT)) }
    static fetchLastBobstoreWardrobe({dispatch}) { return dispatch(getLastBobstoreWardrobe(BOBSTORE_WARDROBE_COUNT)) }
    static fetchLastBobstoreSubmissions({dispatch}) { return dispatch(getLastBobstoreSubmissions(BOBSTORE_SUBMISSION_COUNT)) }
    static fetchLatestFilmsAmateurs({dispatch}) { return dispatch(getLatestFilmsAmateurs(AMATEUR_FILMS_COUNT)) }
    static fetchLastVirtualGifts({dispatch}) { return dispatch(getLastVirtualGifts(VIRTUAL_GIFTS_COUNT)) }
    static fetchSiteDescription({dispatch}) { return dispatch(getMessageOfDay()) }

    static fetchRoomData({dispatch}) {
        return [
            //dispatch(getRoomsHd()),
            dispatch(getRoomsNeo()),
            dispatch(getPersonalRooms())
        ];
    }

    render() {
        let {
            currentUser,
            rooms,
            personalRooms,
            lastRealGifts,
            lastWallPosts,
            lastBobstoreWardrobe,
            lastBobstoreSubmissions,
            latestFilmsAmateurs,
            lastVirtualGifts,
            siteDescription,
            getAllRooms,
            match
        } = this.props;

        let {topListTab} = this.state;

        let neoPersonalDisabled = window && !!window.__neoPersonalDisabled;

        return (
            <div id="wrapper">
                <HeaderIndex currentUser={currentUser} />
                {!currentUser || !currentUser.isLoggedIn() ? <section className="site-description">
                    <div className="content" dangerouslySetInnerHTML={{__html: siteDescription}}/>
                </section> : null}

                {rooms ? rooms.map((room, index) =>
                    <RoomItemNeo key={index} room={room} getAllRooms={getAllRooms} currentUser={currentUser} />
                ) :
                    <Loading/>
                }

                {!neoPersonalDisabled &&
                    <MyBobTV returnPath={getReturnPath({match})}/>
                }

                {personalRooms ?
                    personalRooms.map((room, index) => <RoomItemPersonal key={index} room={room} currentUser={currentUser} />)
                    :
                    <Loading/>
                }

                

                <LastItemsList items={latestFilmsAmateurs} type="video" />
                <LastItemsList items={lastWallPosts} type="wall" />
                <LastItemsList items={lastBobstoreWardrobe} type="wardrobe" />
                <LastItemsList items={lastRealGifts} type="real_gift" />
                {false && <LastItemsList items={lastBobstoreSubmissions} type="bobstore" />}

                <XXLFunctions />
                <LastItemsList items={lastVirtualGifts} type="virtual_gift" />
                <article className="top-lists">
                    <div className="content">
                        <ul className="top-list-tabs">
                            <li onClick={() => this.setTopListTab(1)} className={this.state.topListTab === 1 ? "active" : ""}>{t("The favourites of BobTV")}</li>
                            <li onClick={() => this.setTopListTab(2)} className={this.state.topListTab === 2 ? "active" : ""}>{t("The generous of BobTV")}</li>
                        </ul>
                        <div className="top-list-content">
                            {topListTab === 1
                                ? <FavouritesIndex/>
                                : <GenerousUsersIndex/>
                            }
                        </div>
                    </div>
                </article>
                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        currentUser: state.currentUser,
        rooms: state.main ? state.main.rooms : null,
        personalRooms: state.main ? state.main.personal_rooms : null,
        lastRealGifts: state.main ? state.main.last_real_gifts : null,
        lastWallPosts: state.main ? state.main.last_wall_posts : null,
        lastBobstoreWardrobe: state.main ? state.main.last_bobstore_wardrobe : null,
        lastBobstoreSubmissions: state.main ? state.main.last_bobstore_submissions : null,
        latestFilmsAmateurs: state.main ? state.main.latest_films_amateurs : null,
        lastVirtualGifts: state.main ? state.main.last_virtual_gifts : null,
        siteDescription: state.main ? state.main.site_description : null,
    }),
    null
)(IndexContainer)



// WEBPACK FOOTER //
// ./src/containers/Index.js